import { render, staticRenderFns } from "./Industrial.vue?vue&type=template&id=562d2fbc&scoped=true&"
import script from "./Industrial.vue?vue&type=script&lang=js&"
export * from "./Industrial.vue?vue&type=script&lang=js&"
import style0 from "./Industrial.vue?vue&type=style&index=0&id=562d2fbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562d2fbc",
  null
  
)

component.options.__file = "Industrial.vue"
export default component.exports